import React from "react";

const DownloadIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="download_icon"
      data-name="download"
      {...props}
      width={props.width || "24"}
      height={props.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 16L16 11H13V4H11V11H8L12 16Z"
        fill={props.fill || "#3A8AB9"}
      />
      <path
        d="M20 18H4V11H2V18C2 19.103 2.897 20 4 20H20C21.103 20 22 19.103 22 18V11H20V18Z"
        fill={props.fill || "#3A8AB9"}
      />
    </svg>
  );
};

export default DownloadIcon;
